__turbopack_context__.v({
  "imageContainer": "styles-module__AxXnmq__imageContainer",
});
